module.exports = __webpack_public_path__ + "img/login-logo.94d57a46.png";